import { mergeAttributes } from '@tiptap/core';
import Image from '@tiptap/extension-image';

// Le immagini dei report vengono stampate (A4 e 72mm): non devono mai sforare il contenitore.
export const ReportImage = Image.extend({
    renderHTML({ HTMLAttributes }) {
        return [
            'img',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { style: 'max-width: 100%; height: auto' })
        ];
    }
});
